import React, { createContext, useContext, useEffect, useState } from "react";
import { useAuth } from "./AuthContext";
import db from "../db/database";
import { getCountryData } from "../utils/countryUtils";

const ConfigContext = createContext();

export const AppConfigProvider = ({ children }) => {
    const { currentUser } = useAuth();
    const [activeEnv, setActiveEnv] = useState(null);
    const [country, setCountry] = useState(null);
    const [loading, setLoading] = useState(true);

    // Carga la configuración activa
    useEffect(() => {
        const loadActiveEnv = async () => {
            setLoading(true);
            try {
                const env = await db.environment.filter(e => e.isActive === true).first();
                if (env) {
                    setActiveEnv(env);
                    setCountry(getCountryData(env.country));
                }
            } catch (error) {
                console.error("Error al cargar configuración:", error);
            } finally {
                setLoading(false);
            }
        };
        loadActiveEnv();
    }, [currentUser]);

    // Cambiar de entorno (y actualizar en Dexie)
    const setActiveEnvironment = async (envId) => {
        await db.transaction("rw", db.environment, async () => {
            await db.environment.toCollection().modify({ isActive: false });
            await db.environment.update(envId, { isActive: true });
            const newEnv = await db.environment.get(envId);
            setActiveEnv(newEnv);
            setCountry(getCountryData(newEnv.country));
        });
    };

    return (
        <ConfigContext.Provider
            value={{
                loading,
                activeEnv,       // toda la config activa
                country,         // objeto con info del país (moneda, símbolo, etc.)
                setActiveEnvironment,
            }}
        >
            {children}
        </ConfigContext.Provider>
    );
};

export const useConfig = () => useContext(ConfigContext);
